module.exports = __webpack_public_path__ + "assets/img/gj-code-85f03daa.png";